import { Button, Table, Pagination } from 'antd';
import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { useLocation, history } from 'umi';
import qs from 'qs';
import dayjs from 'dayjs';
import moment from 'moment';
import { AntdInput, AntdSelect, AntdDatePicker } from '@/components/AntdForm';
import request from '@/utils/request';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { download } from '@/utils/downloadUtil';
import webStorage from '@/utils/storageManager';
import {
  TICKET_CHANGE_ORDER_STATUS_INIT,
  VS_ORDER_PRICE_TYPE_INIT,
} from '@/constants';
import IndexStyles from './indexStyles';

export default () => {
  const location = useLocation();
  const { query, pathname } = location;

  const {
    id,
    breadcrumbTitle,
    page = 1,
    pageSize = 20,
    vxNum,
    pool,
    store,
    orderNo,
    mobile,
    startDate,
    endDate,
    startShowDate,
    endShowDate,
    orderStatus,
    refreshTime,
    proNo,
    proName,
    changeStatus,
    priceType,
  } = query;
  const [scrollY, setScrollY] = useState(240);
  const repertoireContainerRef = useRef(null);
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState({
    page,
    pageSize,
  });
  const [searchParams, setSearchParams] = useState({
    vxNum,
    pool,
    store,
    orderNo,
    mobile,
    startDate,
    endDate,
    startShowDate,
    endShowDate,
    orderStatus: orderStatus ? orderStatus.split(',') : [],
    proName,
    proNo,
    changeStatus,
    priceType,
  });
  const { TICKET_CHANGE_ORDER_STATUS, VS_ORDER_PRICE_TYPE } =
    webStorage.get('DICTOBJ') || {};
  const changeStatusList = useMemo(() => {
    return (
      TICKET_CHANGE_ORDER_STATUS?.map((i) => ({
        label: i.nameZh,
        value: i.dictCode,
      })) || TICKET_CHANGE_ORDER_STATUS_INIT
    );
  }, [TICKET_CHANGE_ORDER_STATUS]);
  const priceTypeList = useMemo(() => {
    return (
      VS_ORDER_PRICE_TYPE?.map((i) => ({
        label: i.nameZh,
        value: i.dictCode,
      })) || VS_ORDER_PRICE_TYPE_INIT
    );
  }, [VS_ORDER_PRICE_TYPE]);
  const statusList = [
    {
      value: '1000001',
      label: '台上见',
    },
    {
      value: '1000002',
      label: '六皇后',
    },
    {
      value: '1000003',
      label: '悲惨世界',
    },
    {
      value: '1000004',
      label: '不眠之夜',
    },
    {
      value: '1000005',
      label: 'candor',
    },
    {
      value: '1000006',
      label: '演际',
    },
    {
      value: '1000007',
      label: '双城之战',
    },
    {
      value: '1000008',
      label: '文广',
    },
  ];
  const orderStatusList = [
    {
      value: 'CREATED',
      label: '待支付',
    },
    {
      value: 'PAID',
      label: '待出票',
    },
    {
      value: 'TICKET_ISSUED',
      label: '已出票',
    },
    {
      value: 'COMPLETED',
      label: '已完成',
    },
    {
      value: 'FAILED',
      label: '出票失败',
    },
    {
      value: 'CANCELED',
      label: '交易关闭',
    },
    {
      value: 'REFUNDING',
      label: '退款中',
    },
    {
      value: 'REFUNDED_AMOUNT',
      label: '退款完成',
    },
    {
      value: 'CLOSED',
      label: '已关闭',
    },
  ];

  const columns = [
    {
      title: '剧目名称',
      dataIndex: 'proName',
      width: 173,
    },
    {
      title: '剧目编号',
      dataIndex: 'proNo',
      width: 173,
    },
    {
      title: '订单号',
      dataIndex: 'orderNo',
      width: 222,
    },
    {
      title: '微信交易号',
      dataIndex: 'vxNum',
      width: 173,
    },
    {
      title: '第三方订单号',
      dataIndex: 'thirdOrderNo',
      width: 178,
    },
    {
      title: '手机号',
      dataIndex: 'mobile',
      width: 120,
    },
    {
      title: '下单时间',
      dataIndex: 'tradeTime',
      width: 175,
    },
    {
      title: '学生票',
      dataIndex: 'studentTicket',
      width: 115,
      render: (_, record) => {
        return record.studentTicket === 'STUDENT' ? '是' : '否';
      },
    },
    {
      title: '订单来源',
      dataIndex: 'tradeTime',
      width: 115,
      render: (_, record) => {
        return (
          <div>
            {statusList.find((item) => item.value === record.store)?.label}
          </div>
        );
      },
    },
    {
      title: '演出日期',
      dataIndex: 'showDate',
      width: 175,
    },
    {
      title: '座位数',
      dataIndex: 'tickCnt',
      width: 78,
    },
    {
      title: '票面价',
      dataIndex: 'oldPrice',
      width: 78,
    },
    {
      title: '早鸟价',
      dataIndex: 'birdPrice',
      width: 78,
    },
    {
      title: '应付金额',
      dataIndex: 'amountTotal',
      width: 92,
    },
    {
      title: '实付金额',
      dataIndex: 'amountPaid',
      width: 92,
    },
    {
      title: '折扣金额',
      dataIndex: 'discount',
      width: 92,
      render: (_, record) => {
        return <div style={{ color: '#F5729C' }}>{record.discount}</div>;
      },
    },
    {
      title: '订单状态',
      dataIndex: 'orderStatus',
      width: 92,
      render: (_, record) => {
        return (
          <div>
            {
              orderStatusList.find((item) => item.value === record.orderStatus)
                ?.label
            }
          </div>
        );
      },
    },
    {
      title: '改签状态',
      dataIndex: 'changeStatus',
      width: 115,
      render: (_, record) => {
        return (
          <div>
            {
              changeStatusList?.find(
                (item) => record.changeStatus === item.value,
              )?.label
            }
          </div>
        );
      },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 143,
      render: (_, record) => {
        return (
          <div className="operation-wrap">
            <div
              className="operation-wrap-item"
              onClick={() => handleOpenDetail(record)}
            >
              查看
            </div>
          </div>
        );
      },
    },
  ];

  const replaceHistory = (obj, type) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...searchParams,
        id,
        breadcrumbTitle,
        page: pages.page,
        pageSize: pages.pageSize,
        refreshTime: type ? refreshTime : dayjs().valueOf(),
        orderStatus: searchParams?.orderStatus?.join(',') || '',
        ...obj,
      })}`,
    );
  };
  const handleOpenDetail = (record) => {
    replaceHistory({}, 1);
    history.push({
      pathname: '/dealer/ticket_order_list/order_detail',
      query: {
        id: String(record.id),
        breadcrumbTitle: record.orderId,
        proName,
      },
    });
  };

  const getList = useCallback(() => {
    request('/order/v2/queryOrderPage', {
      method: 'POST',
      data: {
        pageSize: pages.pageSize,
        pageNum: pages.page,
        vxNum: searchParams.vxNum || null,
        orderNo: searchParams.orderNo || null,
        mobile: searchParams.mobile || null,
        pool: searchParams.pool || null,
        store: searchParams.store || null,
        startOrderTime: searchParams.startDate
          ? dayjs(searchParams.startDate).format('YYYY-MM-DD 00:00:00')
          : null,
        endOrderTime: searchParams.endDate
          ? dayjs(searchParams.endDate).format('YYYY-MM-DD 23:59:59')
          : null,
        startShowTime: searchParams.startShowDate
          ? dayjs(searchParams.startShowDate).format('YYYY-MM-DD 00:00:00')
          : null,
        endShowTime: searchParams.endShowDate
          ? dayjs(searchParams.endShowDate).format('YYYY-MM-DD 23:59:59')
          : null,
        orderStatus: searchParams.orderStatus || null,
        searchCount: true,
        proNo: searchParams.proNo || null,
        proName: searchParams.proName || null,
        changeOrderStatus: searchParams.changeStatus || null,
        priceType: searchParams.priceType || null,
      },
    })
      .then((res) => {
        if (res.code === 200 || res.code === 0) {
          setTotal(res.data.total);
          setDataSource(res.data.data || []);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refreshTime]);

  useEffect(() => {
    getList();
  }, [getList]);

  useEffect(() => {
    if (repertoireContainerRef.current) {
      const height =
        repertoireContainerRef.current.clientHeight - 68 - 55.5 - 86 - 25 - 50;
      setScrollY(height);
    }
  }, [repertoireContainerRef]);

  const handleVxNumChange = (e) => {
    setSearchParams({
      ...searchParams,
      vxNum: e.target.value,
    });
  };
  const handleProNameChange = (e) => {
    setSearchParams({
      ...searchParams,
      proName: e.target.value,
    });
  };
  const handleProNoChange = (e) => {
    setSearchParams({
      ...searchParams,
      proNo: e.target.value,
    });
  };
  const handleOrderNoChange = (e) => {
    setSearchParams({
      ...searchParams,
      orderNo: e.target.value,
    });
  };
  const handleMobileChange = (e) => {
    setSearchParams({
      ...searchParams,
      mobile: e.target.value,
    });
  };

  const handleStoreChange = (value) => {
    setSearchParams({ ...searchParams, store: value });
  };
  const handlePriceTypeChange = (value) => {
    setSearchParams({ ...searchParams, priceType: value });
  };

  const handlePerformanceTimeChange = (value) => {
    setSearchParams({
      ...searchParams,
      startDate: value?.[0] ? dayjs(value?.[0]).format('YYYY-MM-DD') : '',
      endDate: value?.[1] ? dayjs(value?.[1]).format('YYYY-MM-DD') : '',
    });
  };

  const handleShowDateChange = (value) => {
    setSearchParams({
      ...searchParams,
      startShowDate: value?.[0] ? dayjs(value?.[0]).format('YYYY-MM-DD') : '',
      endShowDate: value?.[1] ? dayjs(value?.[1]).format('YYYY-MM-DD') : '',
    });
  };

  const handleOrderStatusChange = (value) => {
    setSearchParams({ ...searchParams, orderStatus: value });
  };

  const handleChangeStatusChange = (value) => {
    setSearchParams({ ...searchParams, changeStatus: value });
  };

  const handleSearch = () => {
    setPages({
      page: 1,
      pageSize: 20,
    });
    replaceHistory();
  };
  const handleReset = () => {
    const newSearchParams = {
      vxNum: '',
      orderNo: '',
      mobile: '',
      store: '',
      startDate: '',
      endDate: '',
      startShowDate: '',
      endShowDate: '',
      orderStatus: [],
      proName: '',
      proNo: '',
      changeStatus: '',
      priceType: '',
    };
    setSearchParams(newSearchParams);
    setPages({
      page: 1,
      pageSize: 20,
    });
    replaceHistory(newSearchParams);
  };

  const handleExport = () => {
    download('/order/v2/downLoad', {
      pageSize: pages.pageSize,
      pageNum: pages.page,
      vxNum: searchParams.vxNum || null,
      orderNo: searchParams.orderNo || null,
      mobile: searchParams.mobile || null,
      pool: searchParams.pool || null,
      store: searchParams.store || null,
      startOrderTime: searchParams.startDate
        ? dayjs(searchParams.startDate).format('YYYY-MM-DD 00:00:00')
        : null,
      endOrderTime: searchParams.endDate
        ? dayjs(searchParams.endDate).format('YYYY-MM-DD 23:59:59')
        : null,
      startShowTime: searchParams.startShowDate
        ? dayjs(searchParams.startShowDate).format('YYYY-MM-DD 00:00:00')
        : null,
      endShowTime: searchParams.endShowDate
        ? dayjs(searchParams.endShowDate).format('YYYY-MM-DD 23:59:59')
        : null,
      orderStatus: searchParams.orderStatus || null,
      searchCount: true,
      proNo: searchParams.proNo || null,
      proName: searchParams.proName || null,
      changeOrderStatus: searchParams.changeStatus || null,
      priceType: searchParams.priceType || null,
    });
  };
  return (
    <IndexStyles>
      <div
        className="repertoire-container"
        ref={repertoireContainerRef}
        id="order-container"
      >
        <div className="repertoire-container-search-wrap">
          <div className="repertoire-container-search-wrap-one">
            <AntdDatePicker
              label="下单时间"
              value={
                searchParams.startDate && searchParams.endDate
                  ? [
                      moment(searchParams.startDate, 'YYYY/MM/DD'),
                      moment(searchParams.endDate, 'YYYY/MM/DD'),
                    ]
                  : []
              }
              onChange={handlePerformanceTimeChange}
            />
            <AntdDatePicker
              label="演出日期"
              value={
                searchParams.startShowDate && searchParams.endShowDate
                  ? [
                      moment(searchParams.startShowDate, 'YYYY/MM/DD'),
                      moment(searchParams.endShowDate, 'YYYY/MM/DD'),
                    ]
                  : []
              }
              onChange={handleShowDateChange}
            />
            <AntdInput
              label="剧目名称"
              value={searchParams.proName}
              onChange={handleProNameChange}
            />
          </div>
          <div className="repertoire-container-search-wrap-two">
            <AntdInput
              label="剧目编号"
              value={searchParams.proNo}
              onChange={handleProNoChange}
            />
            <AntdInput
              label="微信交易号"
              labelWidth={65}
              value={searchParams.vxNum}
              onChange={handleVxNumChange}
            />
            <AntdInput
              label="订单号"
              value={searchParams.orderNo}
              onChange={handleOrderNoChange}
            />
          </div>

          <div className="repertoire-container-search-wrap-three">
            <div className="repertoire-container-search-wrap-inner">
              <AntdSelect
                label="订单状态"
                mode="multiple"
                maxTagCount={3}
                options={orderStatusList}
                value={searchParams.orderStatus}
                onChange={handleOrderStatusChange}
              />
              <AntdSelect
                label="订单类型"
                options={priceTypeList}
                value={searchParams.priceType}
                onChange={handlePriceTypeChange}
              />
            </div>
            <div className="repertoire-container-search-wrap-inner">
              <AntdSelect
                label="订单来源"
                options={statusList}
                value={searchParams.store}
                onChange={handleStoreChange}
              />
              <AntdSelect
                label="改签状态"
                options={changeStatusList}
                value={searchParams.changeStatus}
                onChange={handleChangeStatusChange}
              />
            </div>

            <div className="repertoire-container-search-wrap-inner">
              <AntdInput
                label="手机号"
                value={searchParams.mobile}
                onChange={handleMobileChange}
              />
              <div className="repertoire-container-search-wrap-button">
                <Button type="primary" shape="round" onClick={handleSearch}>
                  搜索
                </Button>
                <Button shape="round" onClick={handleReset}>
                  重置
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="repertoire-container-content">
          <Table
            size="small"
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            scroll={{
              y: scrollY,
            }}
          />
        </div>
        <div className="repertoire-container-footer">
          <Pagination
            defaultCurrent={1}
            total={total}
            pageSize={20}
            current={pages.page}
            showSizeChanger={false}
            onChange={(currentPage, currentPageSize) => {
              console.log(currentPage, currentPageSize);
              setPages({
                page: currentPage,
                pageSize: currentPageSize,
              });
              replaceHistory();
            }}
          />
          <div className="repertoire-container-footer-button-wrap">
            <Button
              type="primary"
              shape="round"
              icon={<SvgIconML name="export-icon" size={24} />}
              size="large"
              style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
              onClick={handleExport}
            >
              导出列表数据
            </Button>
          </div>
        </div>
      </div>
    </IndexStyles>
  );
};
